// Port de app/suporte-chat.tsx.
import { Carregando } from "@/app/Carregando";
import { CabecalhoPagina } from "@/components/pageFragment/PageFragment";
import { Stack, useLocalSearchParams } from "@/navigation";
import { useDesktop } from "@/ui/useMediaQuery";
import { lazy } from "react";

const PRIMARY = "#294956";

const SuporteChatScreen = lazy(() => import("@/screens/SuporteChat"));

export default function SuporteChatRoute() {
  const desktop = useDesktop();
  const { perfil } = useLocalSearchParams<{ perfil?: string }>();
  // WEB (desktop ≥1024px, colaborador): cabeçalho do app no topo (empresa, chat, sino),
  // como nas outras telas; o cabeçalho próprio do chat some (classe tv-so-celular).
  const cabecalhoApp = desktop && perfil !== "prestador";
  return (
    <>
      {/* No nativo: statusBarStyle "light" (só Android), cor da barra de status e da barra
          de navegação #294956, sem translucidez. WEB: só a cor vale — vira a
          <meta name="theme-color"> enquanto a tela está aberta. */}
      <Stack.Screen
        options={{
          statusBarBackgroundColor: PRIMARY,
          navigationBarColor: PRIMARY,
          statusBarTranslucent: false,
        }}
      />
      {cabecalhoApp ? (
        <CabecalhoPagina pageIcon="headset-mic" pageTitle="Suporte" pageLabel="Fale com a nossa equipe" headerPaddingBottom={18} />
      ) : null}
      <Carregando cor={PRIMARY}>
        <SuporteChatScreen />
      </Carregando>
    </>
  );
}
